import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    cuentasVirtuales: false,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, bancoId) {
        state.id = bancoId;
        state.nombre = '';
        state.cuentasVirtuales = false;
        state.rowVersion = null;
    },
    'SET_BANCO' (state, banco) {
        state.nombre = banco.nombre.trim();
        state.cuentasVirtuales = (/true/i).test(banco.cuentasVirtuales);
        state.rowVersion = banco.rowVersion;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, bancoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', bancoId);

            if (bancoId != 0) {
                apiAxios.get('bancos/' + bancoId + '/abm' ) 
                    .then(res => {
                        commit('SET_BANCO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                let banco= {
                    nombre: state.nombre.toUpperCase().trim(),
                    cuentasVirtuales: (/true/i).test(state.cuentasVirtuales),
                };

                let url = 'bancos';
                if (state.id != 0) {
                    url += '/' + state.id;
                    banco.rowVersion = state.rowVersion;
                }

                apiAxios.post(url, banco)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}